import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import starIcon from '../../assets/images/star-icon.png'
import shape from '../../assets/images/shape/shape1.svg'
import Loadable from '@loadable/component'
const OwlCarousel = Loadable(() => import('react-owl-carousel3'))

const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  margin: 30,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    992: {
      items: 2,
    },
  },
}

const Testimonials = () => {
  const [display, setDisplay] = React.useState(false)

  React.useEffect(() => {
    setDisplay(true)
  }, [])

  const { testimonials } = useStaticQuery(
    graphql`
      query {
        testimonials: allContentfulTestimonials(
          sort: { fields: createdAt, order: DESC }
        ) {
          edges {
            node {
              name
              position
              image {
                fluid(maxWidth: 51) {
                  src
                }
              }
              quote
            }
          }
        }
      }
    `
  )

  if (!testimonials) {
    return null
  }

  return (
    <div className="testimonials-area pt-100 bg-f1f8fb">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={starIcon} alt="testimonial" />
            Testimonials
          </span>
          <h2>What Our Clients are Saying?</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna.
          </p>
        </div>

        {display ? (
          <OwlCarousel
            className="testimonials-slides owl-carousel owl-theme"
            {...options}
          >
            {testimonials.edges.map((testi, index) => {
              return (
                <div key={index} className="single-testimonials-item">
                  <p>{testi.node.quote}</p>
                  <div className="client-info">
                    <div className="d-flex justify-content-center align-items-center">
                      <img src={testi.node.image.fluid.src} alt="client" />
                      <div className="title">
                        <h3>{testi.node.name}</h3>
                        <span>{testi.node.position}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </OwlCarousel>
        ) : (
          ''
        )}

        <div className="testimonials-view-btn text-center">
          <Link to="/testimonials" className="default-btn">
            <i className="flaticon-view"></i>
            Check Out All Reviews <span></span>
          </Link>
        </div>
      </div>

      <div className="shape-img1">
        <img src={shape} alt="testimonial" />
      </div>
    </div>
  )
}

export default Testimonials
